import { React, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import CommentIcon from "@mui/icons-material/Comment";

import { CommentValidationSchema } from "../../../validators";
import { Common, Marking} from "../../../helper";
import { MarkHeader, MarkRow, MarkDescription } from "./";
import { LoadingSpinner, Header } from "../../Shared";
import { isEmptyArray, isEmptyObject } from "../../../util";
import { fetchDescription, fetchDescriptionMark, fetchgeneralComment, updategeneralComment } from "../../../api/markingApi";
import { setSelect } from "../../../store/stylesSlice";

import "../../../App.scss";
import "../../../assets/stlyes/MarkEditor.scss";

import SaveIcon from "../../../assets/images/Save.png";
import FFEmerging from "../../../assets/images/FloodFillEmerging.png"
import FFExpected from "../../../assets/images/FloodFillExpected.png"
import FFGreater from "../../../assets/images/FloodFillGreater.png"
import FFAbsent from "../../../assets/images/FloodFillAbsent.png"
import FFBelow from "../../../assets/images/FloodFillRed.png"

const EditMark = () => {
  const params = useParams();
  const categoryName = params.categoryName;
  const subjectName = params.subjectName;
  const _subjectClassId = params._subjectClassId;
  const _classId = params._classId;
  const year = params.year;
  const _description = params._description;
  const identifier = params.identifier;

  const [cards, setCards] = useState();
  const [editorData, setEditorData] = useState([]);
  const [_markings, setMarkings] = useState([]);
  const [finalUpdatedData, setFinalUpdatedData] = useState();
  const [pupil, setPupil] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [modalOn, setModalOn] = useState(false);
  const [generalComments, setGeneralComments] = useState();
  const [redFill, setRedFill] = useState(false)

  let isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  const dispatch = useDispatch()

  const _fetchDescriptionMark = async () => {
    setIsLoading(true);
    const data = { id: _classId, subject: subjectName, category: categoryName, year: Number(year), description: _description, subjectId: _subjectClassId }
    const response = await fetchDescriptionMark(data);
    const result = !isEmptyObject(response) && response.Items;
    setPupil(response.Items)
    const arr = result.map((mark) => ({ ...mark, markings: !isEmptyArray(mark.description) ? mark.description[0].markings : ["0"] }));
    !isEmptyArray(arr) && setEditorData(arr);
    const _arr = arr && arr.map((mark) => ({ markings: mark.markings, firstName: mark.firstName, lastName: mark.lastName, upn: mark.upn, id: mark.pupilId, comment: mark.description[0]?.comment !== undefined ? mark.description[0].comment : mark.description }));
    const _arr2 = arr && arr.map((mark) => ({ marks: mark.markings, id: mark.pupilId, markId: mark.markId, comment: mark.description[0]?.comment !== undefined ? mark.description[0].comment : "" }));
    const pupilMarkDetails = {
      pupilId: _arr2,
      subjectid: _subjectClassId,
      category: categoryName,
      generalIdentifier: identifier,
      objectiveYear: parseInt(year),
      currentYear: parseInt(year),
      classId: _classId
    }
    !isEmptyObject(pupilMarkDetails) && setFinalUpdatedData(pupilMarkDetails)
    !isEmptyArray(_arr) && setMarkings(_arr);
    setIsLoading(false);
  }

  const _fetchDescription = async () => {
    const data = { subjectName, description: _description, category: categoryName, generalIdentifier: identifier }
    const response = await fetchDescription(data);
    if (!isEmptyObject(response)) {
      setCards(response.Items.sort((a, b) => a.year - b.year))
    }
  }

  const updateMarks = (index, i) => {
    const data = [..._markings];
    data[index].markings = i + 1;
    setMarkings(data);
  }



  const pupilMarkss = (finalUpdatedData) => {
    setFinalUpdatedData(prevState => ({
      ...prevState,
      ...finalUpdatedData
    }));
  }

  const generalComment = async () => {
    const data = { id: _classId, description: _description, year: parseInt(year) }
    const response = await fetchgeneralComment(data);
    !isEmptyObject(response.Items) && setGeneralComments(response.Items.text)
  }

  const updategeneralComments = async (values) => {
    const data = { id: _classId, description: _description, year: parseInt(year), text: values.comment }
    const response = await updategeneralComment(data);
    if (!isEmptyObject(response.Items)) {
      generalComment();
      setModalOn(false);
    }
  }


  const handleFloodFill = (level) => {
    level == "B" ? setRedFill(true) : setRedFill(false)
    let updatedFinalFlood = finalUpdatedData
    let pupils = updatedFinalFlood.pupilId.map(data => {
      return {
        ...data,
        marks: [`${year}${level}`],
        comment:""
      }
    })
    updatedFinalFlood.pupilId = pupils
    pupilMarkss(updatedFinalFlood)
    let _editorData = editorData.map(data => {
      return {
        ...data,
        markings: [`${year}W`],
        comment:""
      }
    })
    setEditorData(_editorData)
  }

  // const clearAllMarkings = () => {
  //   let updatedFinalFlood = finalUpdatedData
  //   let pupils = updatedFinalFlood.pupilId.map(data => {
  //     return {
  //       ...data,
  //       marks: ["0"]
  //     }
  //   })
  //   updatedFinalFlood.pupilId = pupils
  //   setFinalUpdatedData(updatedFinalFlood)
  //   let _editorData = editorData.map(data => {
  //     return {
  //       ...data,
  //       markings: ["0"]
  //     }
  //   })
  //   setEditorData(_editorData)
  // }

  useEffect(() => {
    dispatch(setSelect("My Classes"))
    _fetchDescription();
    _fetchDescriptionMark();
    generalComment()
  }, [])

  return (
    <div className="Page-layout">
      <Header />
      {isLoading ? <LoadingSpinner /> :
        <div className="Marking-editor-page">
          <div className="marking-editor-page-header"><MarkHeader year={year} _description={_description} generalComments={generalComments} finalUpdatedData = {finalUpdatedData} setIsLoading={setIsLoading} _fetchDescription={_fetchDescription} _fetchDescriptionMark={_fetchDescriptionMark} generalComment={generalComment} setModalOn={setModalOn} /></div>
          <div style={{ paddingRight: ((isNavCollapsed) ? "120px" : "280px"), overflow: "auto", height: "auto" }}>
            
            <div className="marking-editor-page-content">
              <div className="left-content">
                <div className="marking-sheet">
                  <table>
                    <thead>
                      <tr><th></th><th></th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td className="floodfill-row d-flex flex-row">
                          <span className="d-flex flex-column floodfill-row-image" style={{ margin: "10px 85px 10px 0px" }} onClick={() => { handleFloodFill("B") }} onKeyDown={e => { e.key === "Enter" && handleFloodFill("B") }} tabIndex="0" role="button"><img src={FFBelow} alt="" /><span className="floodfill-mark">BLW</span></span>
                          <span className="d-flex flex-column floodfill-row-image" style={{ margin: "10px 85px 10px 0px" }} onClick={() => { handleFloodFill("W") }} onKeyDown={e => { e.key === "Enter" && handleFloodFill("W") }} tabIndex="0" role="button"><img src={FFEmerging} alt="" /><span className="floodfill-mark">WTS</span></span>
                          <span className="d-flex flex-column floodfill-row-image" style={{ margin: "10px 85px 10px 0px" }} onClick={() => { handleFloodFill("E") }} onKeyDown={e => { e.key === "Enter" && handleFloodFill("E") }} tabIndex="0" role="button"><img src={FFExpected} alt="" /><span className="floodfill-mark">EXS</span></span>
                          <span className="d-flex flex-column floodfill-row-image" style={{ margin: "10px 70px 10px 0px" }} onClick={() => { handleFloodFill("G") }} onKeyDown={e => { e.key === "Enter" && handleFloodFill("G") }} tabIndex="0" role="button"><img src={FFGreater} alt="" /><span className="floodfill-mark">GDS</span></span>
                          <span className="d-flex flex-column floodfill-row-image" style={{ margin: "10px 14px 10px 0px", height: "25px", width: "25px" }} onClick={() => { handleFloodFill("A") }} onKeyDown={e => { e.key === "Enter" && handleFloodFill("A") }} tabIndex="0" role="button"><img src={FFAbsent} alt="" /><span className="floodfill-mark floodfill-row-image">Absent</span></span>
                          {/* <button style={{ margin: "18px 0px 0px 0px" }} className="marking-clear-all-button" onClick={clearAllMarkings}>{Common.ClearAll}</button> */}
                        </td>
                        <td></td>
                      </tr>
                      {editorData && editorData.map((ele, index) => (<MarkRow {...ele} key={index} index={index} _markings={_markings} CheckBox={Marking.CheckBox} updateMarks={updateMarks} finalUpdatedData={finalUpdatedData && finalUpdatedData} cards={cards && cards} year={year && year} _description={_description} pupilMarkss={pupilMarkss} pupil={pupil} redFill={redFill} />))}
                    </tbody>
                  </table>
                </div>

              </div>
              <div style={{ marginLeft: "20px", position:"fixed", right:"0px" }}>
                {cards && <MarkDescription cards={cards && cards} year={year && year} />}
              </div>
            </div>
          </div>
        </div>
      }
      <Modal show={modalOn} onHide={() => { setModalOn(false); }} backdrop="static" keyboard={false}>
        <Modal.Title className="d-flex justify-content-between ModalHeader">
          <div className="pupilNameDiv"><CommentIcon /> Comment All Pupils</div>
          <div className="pupilNameDiv" style={{ textAlign: "left" }}>{_description}</div>
        </Modal.Title>
        <Modal.Body>
          <Formik initialValues={{ comment: !isEmptyArray(generalComments && generalComments) ? generalComments : "" }}
            validationSchema={CommentValidationSchema}
            onSubmit={(values) => {
              updategeneralComments(values);
              setModalOn(false);
            }}>
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <Form.Control as="textarea" type="text" name="comment" placeholder="Add Comment" onChange={handleChange} onBlur={handleBlur} value={values.comment} className="array-answer" autoComplete="off" />
                  {touched.comment && errors.comment ? (<p className="error-message">{errors.comment}</p>) : <p>{""}</p>}
                </Form.Group>
                <div className="submit-button-div d-flex justify-content-end">
                  <button className="cancelButton" onClick={() => { setModalOn(false); }} type="button">{Common.Cancel}</button>&nbsp;
                  <button className="saveButton" type="submit" onClick={() => { setModalOn(false); }}
                  ><img src={SaveIcon} alt="Save" />{Common.SaveComment}</button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export { EditMark }